import { getDataMapper, mapField } from "@/shared";

export const mapProductsLeftoverFiltersToServer = getDataMapper({
    point_id: mapField("pointId", Number),
    category_id: mapField("categoryId", Number),
    leftover_zero: mapField("leftover", Boolean),
});
